import { useMemo } from 'react'
import { useModelStore } from '@editorStores'
import { deriveElementCrossSectionAssignment } from 'src/state/utils/deriveElementAssignments'

/**
 * Cross-sections are embedded on planar model elements.
 * This hook derives the legacy `ElementCSAssignment[]` view from that model.
 */
const useElementCrossSectionAssignment = () => {
  const model = useModelStore(state => state.model)

  return useMemo(() => deriveElementCrossSectionAssignment(model), [model])
}

export default useElementCrossSectionAssignment
